import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

export interface InputLabelProps {
  label?: ReactNode;
  rightAction?: ReactNode;
  secondaryLabel?: ReactNode;
  requiredStar?: boolean;
  htmlFor?: string;
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => {
  return {
    labelContainer: {
      display: 'flex',
      marginBottom: theme.marginBase / 2,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    label: {
      ...theme.fonts.label,
    },
    secondaryLabel: {
      ...theme.fonts.caption,
      color: theme.colors.inkSecondary,
    },
    star: {
      color: theme.colors.redAccessible,
    },
  };
});

export const InputLabel = ({
  label,
  rightAction,
  secondaryLabel,
  requiredStar,
  htmlFor,
  className,
}: InputLabelProps) => {
  const classes = useStyles();
  return (
    <>
      {label && (
        <div className={classnames(classes.labelContainer, className)}>
          <label className={classes.label} htmlFor={htmlFor}>
            {label}
            {requiredStar && <span className={classes.star}> *</span>}
          </label>
          {rightAction}
        </div>
      )}
      {secondaryLabel && (
        <div className={classes.labelContainer}>
          <label className={classes.secondaryLabel} htmlFor={htmlFor}>
            {secondaryLabel}
          </label>
        </div>
      )}
    </>
  );
};
